import React from "react";
import { Container } from "react-bootstrap";

const AvtozmaHCP = ({ shouldHideDiv, collapseText, isiTextRef, readLess }) => {
  return (
    <>
      <div
        className={`isi-text-sticky isi-text ${shouldHideDiv ? "d-none" : ""}`}
      >
        <Container className="position-relative">
          <div className="isi-text-wrap responsive-flex">
            <button
              className="isi-text-open open avtozma"
              onClick={collapseText}
            ></button>
            <div style={{ paddingRight: "40px" }}>
              <br />
              <p>
                <strong className="avtozma-color">
                  IMPORTANT SAFETY INFORMATION
                </strong>
              </p>
              <p>
                <strong>
                  AVTOZMA can cause serious side effects, including:
                </strong>
              </p>
              <p>
                <strong>Serious infections</strong>, which may lead to death.
                &nbsp; AVTOZMA can weaken your immune system, increasing the
                risk of infections or worsening existing ones. Your doctor will
                test for tuberculosis (TB) before starting treatment. If you
                have COVID-19, your doctor should monitor you for signs and
                symptoms of new infections during and after treatment with
                AVTOZMA. After starting AVTOZMA, call your doctor right away if
                you have any symptoms of an infection such as fever, chills,
                cough, or other signs of infection.
              </p>
            </div>
            <div style={{ paddingRight: "40px" }}>
              <br />
              <p>
                <strong className="avtozma-color">INDICATIONS</strong>
              </p>
              <p>
                AVTOZMA<sup>&reg;</sup> (tocilizumab-anoh) is a prescription
                medicine used for the treatment of:
                <ul>
                  <li>
                    Adults with moderately to severely active rheumatoid
                    arthritis (RA), after at least one other medicine called a
                    Disease-Modifying Anti-Rheumatic Drug (DMARD) has been used
                    and did not work well
                  </li>
                </ul>
              </p>
            </div>
          </div>
        </Container>
      </div>

      <div className="isi-text" ref={isiTextRef}>
        <Container className="position-relative">
          <div className="isi-text-wrap responsive-flex">
            <button
              onClick={readLess}
              className="isi-text-open closed avtozma"
            ></button>
            <div style={{ paddingRight: "40px" }}>
              <br />
              <p>
                <strong className="avtozma-color">
                  IMPORTANT SAFETY INFORMATION
                </strong>
              </p>
              <p>
                <strong>
                  AVTOZMA can cause serious side effects, including:
                </strong>
              </p>
              <p>
                <strong>Serious infections</strong>, which may lead to death.
                &nbsp; AVTOZMA can weaken your immune system, increasing the
                risk of infections or worsening existing ones. Your doctor will
                test for tuberculosis (TB) before starting treatment. If you
                have COVID-19, your doctor should monitor you for signs and
                symptoms of new infections during and after treatment with
                AVTOZMA. After starting AVTOZMA, call your doctor right away if
                you have any symptoms of an infection such as fever, chills,
                cough, or other signs of infection.
              </p>
              <p>
                <strong>
                  Tears (perforation) in your stomach or intestines.
                </strong>{" "}
                Some people taking AVTOZMA get tears in their stomach or
                intestine. This happens most often in people who also take
                nonsteroidal anti-inflammatory drugs (NSAIDs), corticosteroids,
                or methotrexate. Get medical help right away if you have stomach
                pain that does not go away, and a change in your bowel habits.
              </p>
              <p>
                <strong>Liver problems. </strong>
                Some people have experienced serious life-threatening liver
                problems, which required a liver transplant or led to death.
                Your doctor will monitor your liver function. Call your doctor
                if you experience tiredness, loss of appetite, nausea, dark
                urine, or yellowing of the skin or eyes.
              </p>

              <p>
                <strong> Changes in certain laboratory test results. </strong>
                Your doctor should do blood tests before and during treatment
                with AVTOZMA. Make sure you get all your follow-up blood tests
                done as ordered by your doctor. Your doctor may stop your
                AVTOZMA treatment for a period of time or change your dose of
                medicine if needed because of changes in these blood test
                results.
              </p>
              <p>
                <strong>Cancer. </strong>
                AVTOZMA may increase your risk of certain cancers by changing
                the way your immune system works. Tell your doctor if you have
                ever had any type of cancer.
              </p>
              <p>
                <strong>
                  Do not take AVTOZMA if you are allergic to tocilizumab or any
                  of its ingredients.
                </strong>{" "}
              </p>
              <p>
                <strong>
                  Before taking AVTOZMA, tell your doctor about all your medical
                  conditions, including if you:{" "}
                </strong>
              </p>
              <ul>
                <li>
                  Have infections (with or without a fever), liver problems, or
                  a history of stomach/intestinal ulcers or cancer.
                </li>
                <li>
                  Have diabetes, HIV, or a weak immune system. People with these
                  conditions have a higher chance for infections.
                </li>
                <li>
                  Have or had hepatitis B, tuberculosis (TB), have been in close
                  contact with someone with TB, live or have lived or traveled
                  to certain parts of the country (such as the Ohio and
                  Mississippi River valleys and the Southwest).
                </li>
                <li>
                  Have had an allergic reaction to tocilizumab products or any
                  of its ingredients. </li>
                <li>
                  Have or had a condition that affects your
                  nervous system, such as multiple sclerosis.
                </li>
                <li>
                  Have had a recent or scheduled vaccine (you should not receive
                  live vaccines while on AVTOZMA).
                </li>
                <li>Plan to receive surgery or a medical procedure.</li>
                <li>
                  Are pregnant, planning to become pregnant, or breastfeeding.
                  AVTOZMA may harm your unborn baby. It is not known if AVTOZMA
                  passes into your breast milk.
                </li>
              </ul>
              <p>
                <p>
                  <strong>
                    Also, tell your doctor about all of the medicines you take,
                    including prescription, over-the-counter medicines, vitamins
                    and herbal supplements.
                  </strong>{" "}
                  AVTOZMA and other medicines may affect each other causing side
                  effects. Know the medicines you take. Keep a list of them to
                  show to your healthcare provider and pharmacist when you get a
                  new medicine.
                </p>

                <p>
                  <strong>The most common side effects include: </strong>
                  upper respiratory tract infections (such as colds), headache,
                  high blood pressure, injection site reactions, and increased
                  liver enzyme levels.
                </p>

                <p>
                  <strong>
                    These are not all the possible side effects. Call your
                    doctor right away if you have any symptoms of an infection
                    or experience any side effects.
                  </strong>{" "}
                </p>

                <p>
                  You may report side effects by calling Celltrion USA Inc. at 1-800-560-9414, FDA at 1-800-FDA-1088, or visit www.fda.gov/medwatch.
                </p>
              </p>
            </div>
            <div style={{ paddingRight: "40px" }}>
              <br />
              <p>
                <strong className="avtozma-color">INDICATIONS</strong>
              </p>
              <p>
                AVTOZMA<sup>&reg;</sup> (tocilizumab-anoh) is a prescription
                medicine used for the treatment of:
                <ul>
                  <li>
                    Adults with{" "}
                    <strong>
                      moderately to severely active rheumatoid arthritis (RA)
                    </strong>
                    , after at least one other medicine called a
                    Disease-Modifying Anti-Rheumatic Drug (DMARD) has been used
                    and did not work well
                  </li>
                  <li>
                    Adults with <strong>giant cell arteritis (GCA)</strong>
                  </li>
                  <li>
                    People with{" "}
                    <strong>
                      active polyarticular juvenile idiopathic arthritis (PJIA)
                    </strong>{" "}
                    ages 2 and above
                  </li>
                  <li>
                    People with{" "}
                    <strong>
                      active systemic juvenile idiopathic arthritis (SJIA)</strong>{" "}
                      ages 2 and above
                    
                  </li>
                  <li>
                    Adults and pediatric patients 2 years of age and older with
                    chimeric antigen receptor (CAR) T cell-induced severe or
                    life-threatening <strong>cytokine release syndrome</strong>.
                  </li>
                  <li>
                    Hospitalized adults with{" "}
                    <strong>coronavirus disease 2019 (COVID-19)</strong>{" "}
                    receiving systemic corticosteroids and requiring
                    supplemental oxygen or mechanical ventilation. AVTOZMA is
                    not approved for subcutaneous use in people with COVID-19.
                  </li>
                </ul>
                <br></br>It is not known if AVTOZMA is safe and effective in
                children with PJIA or SJIA under 2 years of age or in children
                with conditions other than PJIA or SJIA.
              </p>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default AvtozmaHCP;
